import { render } from "./App.vue?vue&type=template&id=5faab37c"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=5faab37c&lang=css"

import exportComponent from "/Users/yxgc/Desktop/DATA/res/WorldPress/beeNetPlugin/Bee_RewardPlugin/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.13_vue@3.5.13_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__